import React from "react";

function VoidConfirmationRemarks({ data }) {
  if (data?.remark)
    return (
      <div className="w-full mt-4 flex flex-col gap-4">
        <span className="font-bold text-xl">Void Remarks</span>

        <div className="w-full rounded-lg bg-white p-3 sm:p-4">
          <div className="text-gray-900 text-sm">{data?.remark}</div>
        </div>
      </div>
    );
}

export default VoidConfirmationRemarks;
